import {
  RETRIEVE_REFERRAL,
} from "../actions/types";

const initialState = { referral: [], totalReferralCount: 0 };

const referralReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_REFERRAL:
      return {
        referral: payload.rows,
        totalReferralCount: payload.count,
      };

    default:
      return state;
  }
};

export default referralReducer;